import {Type} from '@wix/ambassador-seating-v1-seating-plan/types'
import {isAreaTicket, isRowTicket, isTableTicket} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Divider} from '../../../components/details-page/Widget/components/status-screens/common/divider'
import {useCurrencyFormatter} from '../../hooks/currency'
import {EventText} from '../event-text'
import {AreaSeatInfo} from './area-seat-info'
import {SeatInfo, TicketWithSeatingProps} from './interfaces'
import {TableRowSeatInfo} from './table-row-seat-info'
import s from './ticket-with-seating.scss'

export const TicketWithSeating = ({ticket}: TicketWithSeatingProps) => {
  const {t} = useTranslation()
  const seatInfo = getSeatInfo(ticket, t)
  const pricingOptionName = ticket.ticketDetails?.pricingOptionName
  const {getFormattedMoney} = useCurrencyFormatter()
  const price = getFormattedMoney(ticket.price)

  const getSeatInfoCol = () => {
    switch (seatInfo.type) {
      case Type.AREA: {
        return <AreaSeatInfo ticket={ticket} seatInfo={seatInfo} />
      }
      case Type.TABLE:
      case Type.ROW:
        return <TableRowSeatInfo seatInfo={seatInfo} />
      default:
        return null
    }
  }

  return (
    <>
      <div className={s.row} role="row">
        <div className={s.colTicket} data-hook={DH.TICKET_NAME} role="cell">
          <EventText>{ticket.name}</EventText>
        </div>
        {getSeatInfoCol()}
        <div className={s.colTotal} role="cell" data-hook={DH.TICKET_PRICE}>
          <EventText>{pricingOptionName ? `${pricingOptionName} - ${price}` : price}</EventText>
        </div>
      </div>
      <Divider />
    </>
  )
}

const getSeatInfo = (ticket: wix.events.ticketing.Ticket, t): SeatInfo => {
  const sectionName = ticket.ticketDetails?.sectorName
  if (isRowTicket(ticket)) {
    return {
      section: sectionName,
      type: Type.ROW,
      seatingInfo: {
        primary: {header: t('order.seating.row'), text: ticket.ticketDetails.rowNumber},
        secondary: {header: t('order.seating.seat'), text: ticket.ticketDetails.seatNumber},
      },
    }
  }
  if (isAreaTicket(ticket)) {
    return {
      section: sectionName,
      type: Type.AREA,
      seatingInfo: {
        primary: {header: t('order.seating.area'), text: ticket.ticketDetails.areaName},
      },
    }
  }
  if (isTableTicket(ticket)) {
    return {
      section: sectionName,
      type: Type.TABLE,
      seatingInfo: {
        primary: {header: t('order.seating.table'), text: ticket.ticketDetails.tableName},
        secondary: {header: t('order.seating.seat'), text: ticket.ticketDetails.seatNumber},
      },
    }
  }
}
